export default __webpack_public_path__ + "a58d26c3fc7ebd23f26bc27161b71836.jpg";